import { isEmpty } from "@s-libs/micro-dash";

const rawFormativeGraphicOrganizers = [
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "✔️PRO/CON Analysis (PDF PRO /CON Analysis)",
    "Dowload PDF": "",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Flowchart",
    "Google Doc": "flowchart worksheet FINAL-uae.pdf",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2018-10-4_Flowchart.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/653028b06dd0a2fb6b37ef9d",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/UN9XM7?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-18/651afdc6fcc9ecb7e46e6f13/653028c9af59eabf3a21743d_2018-10-4_Flowchart.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Connecting people, events, ideas",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "Flowchart",
    "Google Doc": "Venn Diagram no instructions FINAL-uae.pdf",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2017-10-Venn-Diagram.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/65302bebf051d9a528173d35",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/LPSLJY?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-18/651afdc6fcc9ecb7e46e6f13/65302c1dc35f72f0e929436f_2017-10-Venn-Diagram.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Synthesizing texts",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "Structure and Purpose",
    "Google Doc": "structure and purpose worksheet FINAL-uae.pdf",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/StructureandPurpose.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/65303a413d73b00db8a00d7b",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/L6AXFN?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-18/651afdc6fcc9ecb7e46e6f13/65303baaf6d9fbec52a767de_StructureandPurpose.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Text structure",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "I See - I Think - I Wonder",
    "Google Doc": "i see-i think-i wonder FINAL-uae.pdf",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/ISee2CIThink2CIWonder.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/65303e566dd0a2fb6b38191a",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/B9UC9A?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-18/651afdc6fcc9ecb7e46e6f13/65303ea56dd0a2fb6b381971_ISee2CIThink2CIWonder.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "What the text says",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "Paired Text Perspective Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Paired_Text_Perspective_Analysis_.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/65327f2a5d9784dfc6e1a35f",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/GJADE5?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/65327f72274c3ef00664b908_Paired_Text_Perspective_Analysis_.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Connecting people, events, ideas",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y - twice?",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Media Literacy Image Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/4.30.2018.MediaLiteracyImageAnalysis.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/65319587ea0672f556b8bbae",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/ME2X6X?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-19/651afdc6fcc9ecb7e46e6f13/653195bdea0672f556b8bbeb_4.30.2018.MediaLiteracyImageAnalysis.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Interpret multimedia",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Main Idea Graphic Organizer",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/07_22_19_MainIdeaGraphicorganizer.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/653194b328e4c266f2e6a53c",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/RCNA26?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/653288e8610395033a29a692_07_22_1_MainIdeaGraphicorganizer.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Main idea",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Comparing Multiple Sources",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/4.18.18.ComparingMultipleSources.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/6532924c5a0650cbb9e645be",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/FDR3AM?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/653293175d9784dfc6e1e0d9_4.18.18.ComparingMultipleSources.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Point of view & purpose",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "ADAMANT Method",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/ADAMANT_Method.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/653299ca274c3ef006650094",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/7V3994?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/653299eb0426ea1c736de72a_ADAMANT_Method.pdf/page-1.png",
    "Grade Band": "HS",
    "Reading Skill": "Point of view & purpose",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "Summarizing",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Summarizing_-_worksheet.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/6532a254fe166b7e2998e140",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/B7MEFZ?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/6532a29452b359705da711d0_Summarizing_-_worksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Summarization",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Comparing Themes Across Texts",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Comparing_Themes_Across_Texts_-_worksheet.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/6532b0ae8c9a2b9e004840b6",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/R3S5VC?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/6532b0f75a0650cbb9e6983b_Comparing_Themes_Across_Texts_-_worksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Theme",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Evidence -- Conclusion",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/5.1.18_Evidence_Conclusion.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/6532b685274c3ef006659e7a",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/PHSK72?_rid=nskr54",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/6532b6b552b359705da74422_5.1.18_Evidence_Conclusion.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "What the text says",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "Y",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "",
    "Dowload PDF": "FALSE",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Unit Vocabulary",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2017-10-Vocabulary-Worksheet.pdf",
    "Dowload PDF": "TRUE",
    "Formative Link":
      "https://app.formative.com/formatives/6532b9378c9a2b9e0048568c",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/4EBPJ5?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-10-20/651afdc6fcc9ecb7e46e6f13/6532b96bfe166b7e2999237b_2017-10-Vocabulary-Worksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Word meaning & choice",
    Status: "Done",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "✔️Frayer Model (PDF Frayer Model)",
    "Dowload PDF": "",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "Word Study (PDF Word Study)",
    "Dowload PDF": "",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "Word Snapshot (PDF Word Snapshot).",
    "Dowload PDF": "",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "✔️Debate Rubric (PDF Debate Rubric)",
    "Dowload PDF": "",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "",
    "Google Doc": "",
    "Newsela PDF link": "✔️⭐KWL Chart (PDF KWL Chart)",
    "Dowload PDF": "",
    "Formative Link": "",
    "Formative Clone Link": "",
    "PNG URL": "",
    "Grade Band": "",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Comparing Media Note Catcher",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Comparing_Media_Note_Catcher.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657772638a29401635cd45a5",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/6MTPDC?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-11/651afdc6fcc9ecb7e46e6f13/65777b337be65098220d61c4_Comparing_Media_Note_Catcher.pdf/page-1.png",
    "Grade Band": "",
    "Reading Skill": "Interpret multimedia",
    Status: "",
  },
  {
    "Graphic Organizer Title": "PRO/CON Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/PRO3ACONanalysis.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6570bc3bff1b796d10cc77cf",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/HRVBTK?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-06/651afdc6fcc9ecb7e46e6f13/6570bcc45b3f4896114ce1e4_PRO3ACONanalysis.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Arguments & claims",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Cause and Effect",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2017-12-Cause-Effect-Tchart.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657775d58a29401635cd48f2",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/95X5SS?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-11/651afdc6fcc9ecb7e46e6f13/657776078a29401635cd493d_2017-12-Cause-Effect-Tchart.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "Connecting people, events, ideas",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Web Chart",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Web_Chart.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a0d0e482afaaae9e8875c",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/WTSD62?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a0d3e321db241b9d5e06c_Web_Chart.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Connecting people, events, ideas",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Perspective Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2018-1-Perspective-Analysis.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657786ff84a63e5b2b33d114",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/6LY4Q3?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-11/651afdc6fcc9ecb7e46e6f13/6577872b8062b84f2f10417b_Perspectiveanalysisworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Connecting people, events, ideas",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Comparing Characteristics",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/07_22_19_Comparing_Characteristics.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6578970e4ec2dd923c76dd83",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/FF77CD?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-12/651afdc6fcc9ecb7e46e6f13/6578973f885ca2abde2fef95_Comparingcharacteristicsworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Connecting people, events, ideas",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Paired Image Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/PairedImageAnalysis.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657899a83f4efddee51fc251",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/N5KNDK?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/6579d228a40f8e0cdd2f27be_PairedImageAnalysis.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Interpret multimedia",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Image Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2018-1-Image-Analysis.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6578a5c37ce1a28c5f9b8145",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/54DWUB?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-12/651afdc6fcc9ecb7e46e6f13/6578a6017ce1a28c5f9b81d4_Imageanalysisworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Interpret multimedia",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Headlines",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Headlines.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6578ad17432613a041bad70f",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/2N6XNK?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-12/651afdc6fcc9ecb7e46e6f13/6578ad56c92c97e666612000_Headlines.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Main idea",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Article Recommendation",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2017-10-30-PTRArticleRec.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6578afb44ec2dd923c770cc9",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/ENLR4S?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-12/651afdc6fcc9ecb7e46e6f13/6578b449432613a041bae5f4_ArticleRecommendationworksheet1.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Main idea",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Opinion Article Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/5.2.2018.OpinionArticleAnalysis.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6579d3fe4820bd801886ae08",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/J3JER6?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/6579d4237c6f1d83ffb27fb6_OpinionArticleAnalysisworksheet.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "Main idea",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Central Idea Notetaker",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Central_Idea_Notetaker_-_Make_a_Copy_1.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6579fe30c32273fa319942e3",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/T4FVTG?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a09faf89e7c6abf6ea32e_Centralideanotetakerworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Main idea",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Triple Venn Diagram",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/10.3.19_Triple.Venn.Diagram.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a0eefbbf1d9d317098568",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/B9CET7?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a0f24321db241b9d5e2e7_Triplevenndiagramworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "3 Column Chart",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/4.12.193-column-chart2020-02-25-01-01-53.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657b62efc14b9a4b81937510",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/D8FW84?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-14/651afdc6fcc9ecb7e46e6f13/657b630d374c77124d7cc3d2_3Columnchartworksheet1.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Public Service Announcement (PSA)",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/NewselaPSAWorksheet.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a11d11f92c2b163f084f1",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/MNKNQX?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a125d59d1cf61f81bb081_PublicserviceannouncementPSAworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Jigsaw Worksheet",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/NewselaJigsaw2.1.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a140488b5618941332f8c",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/EMW9WW?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a14141f92c2b163f0874d_Jigsawworksheet.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "Summarization",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Triad Jigsaw Activity",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/JigsawTriadActivity2020-02-25-00-58-44.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a15a1bbf1d9d317099b1e",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/UBTA4K?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a15b5bbf1d9d317099b34_TriadJigsawActivityworksheet.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "Summarization",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Fiction: Elements of Setting",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/9_18_18Fiction_setting.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a1765bf02c6d194831b37",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/L8E5EF?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a177e321db241b9d5f2d0_Fiction-elementsofsettingworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Text structure",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Research Notes",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Research_Notes.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a189f1f92c2b163f08fe1",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/7WUABY?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a18ad59d1cf61f81bbf9b_Researchnotesworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "What the text says",
    Status: "",
  },
  {
    "Graphic Organizer Title": "3-2-1 Bridge",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/3-2-1Bridge.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a218c8a3b3665c050bc35",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/FFUWD3?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a21ae88b5618941334108_3-2-1-bridgeworksheet.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "What the text says",
    Status: "",
  },
  {
    "Graphic Organizer Title": "RACE Writing Strategy",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/RACEWritingStrategy.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a234f59d1cf61f81be6ff",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/2RGU47?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a2361321db241b9d5fe8f_RACEwritingstrategyworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "What the text says",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Paired Text Analysis",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2017-10-Paired-Text.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a24540bb8f759b5ee8195",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/CP2RP5?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a24990bb8f759b5ee81ea_Pairedtextanalysisworksheet.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "What the text says",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Let's Debate",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/5.5.18_Debate.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a25614102058dbe2a8137",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/B6AYFY?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a257c8a3b3665c050bf47_Letsdebateworksheet.pdf/page-1.png",
    "Grade Band": "MS-HS",
    "Reading Skill": "What the text says",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Visualization",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/4.21.2018_Visualization.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/653290ef0426ea1c736dd217",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/KNEVUB?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/657a27e3f89e7c6abf6eca7c_Visualizationworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "What the text says",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Opinion Response with Counterclaim",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/Opinion_Response_with_Counterclaim.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657a2aedf821ace71d6aef08",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/2H64EN?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-14/651afdc6fcc9ecb7e46e6f13/657b5de9c14b9a4b81936e8b_Opinion_Response_with_Counterclaim.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Arguments & claims",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Frayer Model",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2018.5.3.WordKnowledge.FrayerModel.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657b5f62ad6d8f129ed03f11",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/LGWGQB?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-14/651afdc6fcc9ecb7e46e6f13/657b5fd1eaa3cd473f1d9731_Buildingwordknowledgeworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Word meaning & choice",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Word Study",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/WordStudy.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657b60d33a9f49f3a4d93910",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/UCPWKF?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-14/651afdc6fcc9ecb7e46e6f13/657b6117e31a37d9e8dac16e_Wordstudy.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Word meaning & choice",
    Status: "",
  },
  {
    "Graphic Organizer Title": "Word Snapshot",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/WordSnapshot.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/657b6213c14b9a4b81937402",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/A7ZHUC?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-14/651afdc6fcc9ecb7e46e6f13/657b621f06508296e61a6677_Wordsnapshotworksheet.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "Word meaning & choice",
    Status: "",
  },
  {
    "Graphic Organizer Title": "KWL Chart",
    "Google Doc": "",
    "Newsela PDF link":
      "https://media.newsela.com/article_media/extra/2017-11-6-KWL-Chart.pdf",
    "Dowload PDF": "",
    "Formative Link":
      "https://app.formative.com/formatives/6579fc94482afaaae9e8694d",
    "Formative Clone Link":
      "https://app.formative.com/lti/newsela/launch/clone/JVW4U3?_rid=5og310",
    "PNG URL":
      "https://dm2ec218nt2z5.cloudfront.net/2023-12-13/651afdc6fcc9ecb7e46e6f13/6579fcd3bf02c6d19482f0b3_2017-11-6-KWL-Chart.pdf/page-1.png",
    "Grade Band": "ALL",
    "Reading Skill": "What the text says",
    Status: "",
  },
];

const cleanOrganizerMapping = () => {
  return rawFormativeGraphicOrganizers.filter((organizer) => {
    return (
      !isEmpty(organizer["Graphic Organizer Title"]) &&
      !isEmpty(organizer["Formative Clone Link"]) &&
      !isEmpty(organizer["Reading Skill"]) &&
      !isEmpty(organizer["Grade Band"])
    );
  });
};

const FORMATIVE_GRAPHIC_ORGANIZERS = cleanOrganizerMapping();

export default FORMATIVE_GRAPHIC_ORGANIZERS;
